export default {
    ENV: 'test',
    API_HOST: 'https://api.t9sports.cn',
    HOST: '',
    APP_ID: '',
    WX_APP_ID: 'wxd0ba71665d141047'
}
